/**
 * Compose a middleware chain into a single {@link InstrumentationSend}. The
 * returned `send` resolves context once, runs each middleware in order, and
 * forwards the (possibly transformed) event to `terminal` — unless a middleware
 * returns `{ state: 'stop' }`, which suppresses it.
 *
 * Error isolation: a throwing middleware is reported via `onError` and skipped
 * (the event proceeds unchanged); the terminal is wrapped too, so a faulty
 * side-effect can never break primary analytics. The composed `send` never throws.
 */
export function composeInstrumentationMiddleware({ terminal, middleware, getContext, onError, }) {
    return (event) => {
        const context = getContext();
        let current = event;
        for (const [index, step] of middleware.entries()) {
            let result;
            try {
                result = step(current, context);
            }
            catch (error) {
                onError(error, index);
                continue;
            }
            if (result.state === 'stop') {
                return;
            }
            current = result.event;
        }
        try {
            terminal(current);
        }
        catch (error) {
            onError(error, middleware.length);
        }
    };
}
//# sourceMappingURL=composeInstrumentationMiddleware.js.map